window.SmileTranslator = class SmileTranslator {
    constructor(translationMap, dynamicTextMap) {
        this.translationMap = this._buildCaseInsensitiveMap(translationMap);
        this.dynamicTextMap = dynamicTextMap;
        this.observer = null;
        this.panelCloseInterval = null;
        this.targetNode = null;
        this.isObserving = false;
        this.maxRetries = 30;
        this.retryCount = 0;
    }

    _buildCaseInsensitiveMap(originalMap) {
        const newMap = {};
        for (const key in originalMap)
        {
            newMap[key.toLowerCase()] = originalMap[key];
        }
        return newMap;
    }

    start() {
        this.retryCount = 0;
        this._findIframeAndStart();
        this._watchForPanelClose();
    }

    stop() {
        if (this.observer)
        {
            this.observer.disconnect();
            this.isObserving = false;
            console.log("Smile Translator stopped observing mutations.");
        }
        if (this.panelCloseInterval)
        {
            clearInterval(this.panelCloseInterval);
            this.panelCloseInterval = null;
            console.log("Smile Translator stopped watching for panel close.");
        }
        document.dispatchEvent(new Event('smile-panel-closed')); // Smile.io 패널이 닫혔을 때 커스텀 이벤트 발생
    }

    _findIframeAndStart() {
        const iframe = document.querySelector('iframe.smile-panel-frame');

        if (iframe)
        {
            const setupObserver = () => {
                console.log("Smile iframe loaded. Initializing observer setup...");
                this._findTargetAndObserve(iframe);
            };

            if (iframe.contentDocument && iframe.contentDocument.readyState === 'complete')
            {
                setupObserver();
            }
            else
            {
                iframe.onload = setupObserver;
            }
        }
        else if (this.retryCount < this.maxRetries)
        {
            this.retryCount++;
            setTimeout(() => this._findIframeAndStart(), 500);
        }
        else
        {
            console.error("Smile Translator: Could not find iframe after multiple retries.");
            this.stop(); // iframe을 찾지 못하면 모든 동작을 중지
        }
    }

    _watchForPanelClose() {
        // 기존 인터벌이 있다면 중지
        if (this.panelCloseInterval)
        {
            clearInterval(this.panelCloseInterval);
        }

        this.panelCloseInterval = setInterval(() => {
            const iframe = document.querySelector('iframe.smile-panel-frame');
            if (!iframe)
            {
                console.log("Smile iframe not found. Stopping translator and watcher.");
                this.stop(); // stop() 메소드가 인터벌도 클리어해줌
            }
        }, 500);
    }

    _findTargetAndObserve(iframe) {
        try
        {
            const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
            // .main-panel-container 뿐만 아니라 ReactModalPortal 등 모달 요소도 iframe body에 직접 붙으므로 body 전체를 관찰합니다.
            this.targetNode = iframeDoc.body || iframeDoc.querySelector('.main-panel-container');

            if (this.targetNode)
            {
                console.log("Smile panel target found. Starting translator...");
                this._initObserver(iframeDoc);
                this._translateSubtree(this.targetNode);
            }
        }
        catch (e)
        {
            console.error("Smile Translator: Error accessing iframe content.", e);
            this.stop();
        }
    }

    _initObserver(ownerDocument) {
        if (this.isObserving) return;

        this.observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList)
            {
                if (mutation.type === 'childList')
                {
                    mutation.addedNodes.forEach(node => {
                        this._translateSubtree(node);
                    });
                }
                else if (mutation.type === 'characterData')
                {
                    this._translateNode(mutation.target);
                }
            }
        });

        const config = {
            childList: true,
            subtree: true,
            characterData: true
        };

        this.observer.observe(this.targetNode, config);
        this.isObserving = true;
    }

    _translateSubtree(rootNode) {
        if (!rootNode) return;
        if (rootNode.nodeType === 3) { // TEXT_NODE 단일 추가 케이스 완벽 대응
            this._translateNode(rootNode);
            return;
        }
        if (typeof rootNode.querySelectorAll !== 'function') return;

        const walker = (rootNode.ownerDocument || document).createTreeWalker(rootNode, NodeFilter.SHOW_TEXT);
        let node;
        while (node = walker.nextNode())
        {
            this._translateNode(node);
        }
    }

    _translateNode(node) {
        if (!node || !node.nodeValue) return;
        let originalText = node.nodeValue;
        // &nbsp; (\u00A0) 및 각종 유니코드 공백을 일반 공백으로 치환하여 비교 준비
        let normalizedText = originalText.replace(/[\u00A0\u1680\u180E\u2000-\u200B\u202F\u205F\u3000\uFEFF]/g, ' ');
        let trimmedText = normalizedText.trim();
        if (!trimmedText) return;

        // 1. 정적 텍스트 번역 (전체 일치, 대소문자 구분 없이)
        const lowerCaseText = trimmedText.toLowerCase();
        if (this.translationMap[lowerCaseText])
        {
            node.nodeValue = ` ${this.translationMap[lowerCaseText]} `;
            return;
        }

        // 2. 동적 텍스트 번역 (정규식 - i 플래그로 대소문자 구분 없음)
        let currentText = normalizedText;
        let hasReplaced = false;

        for (const item of this.dynamicTextMap)
        {
            item.regex.lastIndex = 0; // test() 실행 전 정규식 매칭 위치를 항상 처음(0)으로 초기화
            if (item.regex.test(currentText))
            {
                item.regex.lastIndex = 0; // replace() 실행 직전 정규식 상태 한 번 더 초기화
                currentText = currentText.replace(item.regex, item.replacement);
                hasReplaced = true;
            }
        }

        if (hasReplaced)
        {
            node.nodeValue = currentText;
        }
    }
}
